import React from 'react';
import { Section } from './ui/Section';
export function ProductOverview() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  const steps = [{
    n: '1',
    title: 'Identifica',
    desc: 'Qué función cumple el ingrediente.'
  }, {
    n: '2',
    title: 'Sustituye',
    desc: 'Elige una alternativa adecuada.'
  }, {
    n: '3',
    title: 'Reconstruye',
    desc: 'Recupera estructura, textura y resultado.'
  }];
  return <Section data-id="element-155" data-mp="1omhtwfp88paf">
      <div className="max-w-2xl mx-auto text-center mb-10" data-id="element-156" data-mp="1om800h129xzg">
        <h2 className="font-display text-2xl md:text-4xl font-bold text-brand-title mb-4 leading-tight" data-id="element-157" data-mp="1jny76d2t79h0">
          No se trata solo de quitar. Se trata de reconstruir.
        </h2>
        <p className="text-brand-text font-body leading-relaxed" data-id="element-158" data-mp="3e0eap64809i6">
          El Sistema Mimetismo Nutricional™ te enseña a entender qué función
          cumple cada ingrediente para poder sustituirlo y reconstruir
          textura, estructura y sabor utilizando alternativas al gluten.
        </p>
      </div>

      <div className="max-w-2xl mx-auto grid grid-cols-3 gap-3 md:gap-6 mb-10" data-id="element-159" data-mp="qg3re88mtodz">
        {steps.map((step, i) => <div key={i} className="text-center" data-id="element-160" data-mp="vfgbil84chcv" data-mpi={i}>
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-brand-primary text-white font-heading font-bold flex items-center justify-center mx-auto mb-3 text-base md:text-lg" data-id="element-161" data-mp="vg889zdgcl4q">
              {step.n}
            </div>
            <h3 className="font-heading font-bold text-brand-title text-sm md:text-base mb-1 uppercase tracking-wide" data-id="element-162" data-mp="19eg2w0n0nacq">
              {step.title}
            </h3>
            <p className="font-body text-brand-textMuted text-xs md:text-sm leading-snug" data-id="element-163" data-mp="1eb6fgdzm3nte">
              {step.desc}
            </p>
          </div>)}
      </div>

      <div className="text-center" data-id="element-164" data-mp="26ulqoopfs8dd">
        <button onClick={scrollToPricing} className="bg-brand-primary hover:bg-brand-primaryHover text-white font-heading font-bold text-base md:text-lg py-3.5 px-8 rounded-xl transition-colors shadow-card" data-id="element-165" data-mp="26vn3axm3p2x7">
          Quiero acceder al sistema →
        </button>
      </div>
    </Section>;
}